import React from "react";

const NotFound = (props) => {
  return <div>NotFound</div>;
};

export default NotFound;
